// src/services/unidadeOrganicaService.js
import api from '../services/api';

export const listarUnidadesOrganicas = async () => {
    return api.get('/unidades-organicas');
};

export const obterUnidadeOrganica = async (id) => {
    return api.get(`/unidades-organicas/${id}`);
};

export const criarUnidadeOrganica = async (unidade) => {
    return api.post('/unidades-organicas', unidade);
};

export const atualizarUnidadeOrganica = async (id, unidade) => {
    return api.put(`/unidades-organicas/${id}`, unidade);
};

export const excluirUnidadeOrganica = async (id) => {
    return api.delete(`/unidades-organicas/${id}`);
};